import { useEffect, useRef } from 'react';

const TRUST_ITEMS = [
  { icon: 'ri-award-fill', label: 'UCLA Trained', sub: 'Formal Design Education' },
  { icon: 'ri-building-4-line', label: 'Beverly Hills Studio', sub: '215 N La Peer Dr, 90211' },
  { icon: 'ri-newspaper-line', label: 'Elle Décor Featured', sub: 'Editorial Recognition' },
  { icon: 'ri-newspaper-fill', label: 'Architectural Digest', sub: 'Editorial Recognition' },
  { icon: 'ri-vip-crown-line', label: 'Celebrity Clientele', sub: 'High-Net-Worth Projects' },
  { icon: 'ri-global-line', label: 'Nationwide Service', sub: 'US-Wide Project Leadership' },
];

export default function TrustBar() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        el.querySelectorAll('.reveal').forEach((node, i) => {
          setTimeout(() => node.classList.add('revealed'), i * 80);
        });
        obs.disconnect();
      }
    }, { threshold: 0.2 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-charcoal relative overflow-hidden">
      {/* Subtle texture line */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-stone/30 to-transparent" />

      <div className="max-w-[1400px] mx-auto px-8 py-5">
        <div className="flex flex-wrap items-center justify-center lg:justify-between gap-x-8 gap-y-4">
          {TRUST_ITEMS.map((item, i) => (
            <div key={i} className="reveal flex items-center gap-3">
              <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-stone text-base`} />
              </div>
              <div>
                <p className="text-cream/85 text-[11px] font-medium tracking-wider font-sans whitespace-nowrap">{item.label}</p>
                <p className="text-cream/30 text-[9px] tracking-widest uppercase font-sans whitespace-nowrap">{item.sub}</p>
              </div>
              {i < TRUST_ITEMS.length - 1 && (
                <div className="hidden xl:block w-px h-6 bg-cream/8 ml-4" />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Publications ribbon at bottom */}
      <div className="border-t border-cream/5 py-3">
        <div className="max-w-[1400px] mx-auto px-8 flex items-center justify-center gap-6">
          <div className="w-8 h-px bg-stone/30" />
          <span className="text-cream/20 text-[9px] tracking-[0.3em] uppercase font-sans">As Featured In</span>
          <span className="text-stone/70 font-display italic text-sm">Elle Décor</span>
          <div className="w-px h-3 bg-cream/10" />
          <span className="text-stone/70 font-display italic text-sm">Architectural Digest</span>
          <div className="w-8 h-px bg-stone/30" />
        </div>
      </div>
    </section>
  );
}
